
import Menu from '@/components/menu/menu.vue'
import { getBillchannel, getbillCompare, deleteBillpms, postBillpms, putBillpms, putBill } from '@/api/ota'
import { export_json_to_excel } from '@/vendor/Export2Excel'
import Vue from 'vue'
import { cloneDeep } from 'lodash'
export default Vue.extend({
	components: {
		Menu,
	},
	data() {
		return {
			bill_code: '' as any,
			orderDetailDialog: false,
			editOrderDialog: false,
			pms_room_code_list: [] as any,
			showInfo2: true,
			hotels: [] as any, // 酒店选项
			status: [
				{
					id: 0,
					name: '全部',
				},
				{
					id: 1,
					name: '使用中',
				},
				{
					id: 2,
					name: '已停用',
				},
			],
			searchForm: {
				pms_hotel_code: '',
				pms_hotel_id: '',
				complex: '',
				status: 0,
			},
			editHotelDialog: false,
			hotel_submit_form_title: '',

			room_type_form: {
				id: undefined as string | undefined,
				sale_type: '',
				pms_room_code: '',
				sale_room_name: '',
				sale_room_code: '',
				sale_info: [
					{
						sale_room_name: '',
						sale_room_code: '',
						sale_type: '',
					},
				],
			},
			editRoomDialog: false,
			room_type_form_title: '',
			orderStauts: '1' as any,
			table_data: [
				// {
				// 	pms.nights: 1,
				// 	pms.amount: 100,
				// },
			],
			table_state: {
				loading: false,
			},
			mapTypeList: [
				{
					name: '酒店名称',
					value: '1',
					disabled: false,
					id: '1',
				},
				{
					name: '房型名称',
					value: '2',
					disabled: false,
					id: '2',
				},
			],
			src_channel: '携程',
			old_ding_secret: '',
			old_ding_webhook: '',
			settlement_date: '' as any,
			hotelname: '' as any,
			table_data_detail: [],
			table_data_editlist: [] as any,
			statusList: {
				1: '缺失',
				2: '一致',
				3: '差异',
			},
			pms_hotel_code: '' as any,
			complex: '' as any,
			table_data_bill: [] as any,
		}
	},
	computed: {
		returnTotalStatus() {
			let src_channel_nights = 0
			let src_channel_amount = 0
			let pms_nights = 0
			let pms_commission = 0
			let pms_amount = 0
			let pms_total_amount = 0

			this.table_data.forEach((item) => {
				let src_channel = (item as any).src_channel
				let pms = (item as any).pms
				if (!Array.isArray(src_channel)) {
					src_channel_nights += Number((src_channel as any).nights)
					src_channel_amount += Number((src_channel as any).amount)
				}
				if (!Array.isArray(pms)) {
					pms_nights += Number((pms as any).nights)
					pms_commission += Number((pms as any).commission)
					pms_amount += Number((pms as any).amount)
				}
				pms_total_amount = pms_commission + pms_amount
			})
			if (src_channel_nights == pms_nights && src_channel_amount == pms_total_amount) {
				return false
			} else {
				return true
			}
		},
		returnTotalMoney() {
			return function (num1, num2) {
				let nums = Number(num1) + Number(num2)
				return Number(nums).toFixed(2)
			}
		},
		returnCompareResult() {
			return function (channel, pms) {
				if (Array.isArray(channel)) {
					return 1
				}
				if (Array.isArray(pms)) {
					return 1
				}
				let totalnums = Number(pms.commission) + Number(pms.amount)
				if (channel.amount == totalnums && channel.nights == pms.nights) {
					return 2
				} else {
					return 3
				}
			}
		},
		topMenuList() {
			const param = [
				{
					name: '携程订单',
					value: '1',
					info: '携程',
					disabled: false,
					id: '1',
				},
				{
					name: '美团订单',
					value: '3',
					info: '美团',
					disabled: false,
					id: '2',
				},
				{
					name: '马蜂窝订单',
					value: '2',
					info: '马蜂窝',
					id: '4',
				},
				{
					name: '同城订单',
					value: '待定',
					info: '马蜂窝',
					disabled: true,
					id: '3',
				},
				{
					name: '飞猪订单',
					value: '4',
					info: '飞猪',
					disabled: true,
					id: '5',
				},
				{
					name: '驴妈妈订单',
					value: '驴妈妈',
					info: '5',
					disabled: true,
					id: '6',
				},
				{
					name: '途牛订单',
					value: '6',
					info: '途牛',
					disabled: true,
					id: '7',
				},
			]
			if (this.$store.state.admin.info.id == 1 || this.$store.state.admin.info.role_id == 19) {
				return param
			} else {
				return param.slice(0, 1)
			}
		},
		returnChannelinfo() {
			return (info, channelStr) => {
				return info.replaceAll('携程', channelStr)
			}
		},
	},
	created() {
		// orderStauts  1 编辑 2展示
		this.orderStauts = this.$route.query.editstatus
		this.bill_code = this.$route.query.billcode
		this.settlement_date = this.$route.query.settlement_date
		this.hotelname = this.$route.query.hotelname
		this.pms_hotel_code = this.$route.query.pms_hotel_code
		this.complex = this.$route.query.complex

		if (this.orderStauts == '1') {
			this.getTableList()
		} else {
			this.getbillList()
		}
	},
	methods: {
		goBack() {
			this.$router.push({
				name: 'statement_of_account',
			})
		},
		// 计算合计数值
		getSummaries(param) {
			const { columns, data } = param
			const sums = [] as any
			// console.log('columns', columns) // 单元格信息
			let totalsListsNum = 0
			columns.forEach((column, index) => {
				// console.log('column', column)
				if (index === 0) {
					sums[index] = '总价'
					return
				}
				let keys = String(column.property).split('.')
				// console.log(keys)
				if (index === 1 || index == 3) {
					let nums = 0
					for (let index2 = 0; index2 < data.length; index2++) {
						const element = data[index2]
						let key = keys[0]
						if (!Array.isArray(element[key])) {
							// nums += Number(element[key][keys[1]])
							nums = Number(nums) + Number(element[key][keys[1]])
						}
					}
					sums[index] = nums
				}
				if (index == 2 || index == 4 || index == 5) {
					let nums = '0'
					for (let index2 = 0; index2 < data.length; index2++) {
						const element = data[index2]
						let key = keys[0]
						if (!Array.isArray(element[key])) {
							// nums += Number(element[key][keys[1]])
							nums = (parseFloat(nums) + parseFloat(element[key][keys[1]])).toFixed(2)
						}
					}
					sums[index] = nums
				}
				if (keys[0] == 'totalnums') {
					let numtotal = '0'
					for (let index3 = 0; index3 < data.length; index3++) {
						let key1 = 'commission'
						let key2 = 'amount'
						const element = data[index3].pms
						if (!Array.isArray(element)) {
							numtotal = (parseFloat(numtotal) + parseFloat(element[key1]) + parseFloat(element[key2])).toFixed(2)
						}
					}
					sums[index] = numtotal
				}
				if (keys[0] == 'pms_compare_code') {
					if (sums[1] == sums[3] && sums[2] == sums[6]) {
						sums[index] = '平账'
					} else {
						sums[index] = '差异'
					}
				}
			})
			return sums
		},
		// 计算表格样式
		rowStyle({ row, rowIndex }) {
			let channel = row.src_channel
			let pms = row.pms
			if (Array.isArray(channel)) {
				return {
					color: 'red',
				}
			}
			if (Array.isArray(pms)) {
				return {
					color: 'red',
				}
			}

			let totalnums = Number(pms.commission) + Number(pms.amount)

			if (channel.amount == totalnums && channel.nights == pms.nights) {
				return {}
			} else {
				return {
					color: 'red',
				}
			}
		},
		// 获取账单明细
		getbillList() {
			getBillchannel({
				bill_code: this.bill_code,
			}).then((res) => {
				if (res.code == 0) {
					this.table_data_bill = res.data
					let totalInfo = {
						order_code: '合计',
						amount: 0,
						nights: 0,
					}
					totalInfo.amount = res.data.reduce((pre, item) => {
						return (parseFloat(pre) + parseFloat(item.amount)).toFixed(2)
					}, 0)
					totalInfo.nights = res.data.reduce((pre, item) => {
						return Number(pre + Number(item.nights))
					}, 0)
					this.table_data_bill.push(totalInfo)
				}
			})
		},
		// 获取未平账账单
		getTableList() {
			getbillCompare({
				bill_code: this.bill_code,
				pms_hotel_code: this.pms_hotel_code,
				complex: this.complex,
			}).then((res) => {
				if (res.code == 0) {
					if (!Array.isArray(res.data)) {
						let tableList = [] as any
						for (const [key, value] of Object.entries(res.data)) {
							let obj = {
								ordernum: key,
								...value,
							}
							tableList.push(obj)
						}
						this.table_data = tableList
					}
				}
			})
		},
		handleEdit(row, firstLevelKey, secondLevelKey) {
			if (!row.edit) {
				this.$set(row, 'edit', {})
			}
			this.$set(row.edit, firstLevelKey, {})
			this.$set(row.edit[`${firstLevelKey}`], secondLevelKey, true)
			this.$nextTick(() => {
				// 自动聚焦输入框
				const input = this.$el.querySelector(`.el-input__inner`)
				if (input) (input as any).focus()
			})
		},
		handleBlur(row, first, second) {
			row.edit[first][second] = false
			// 这里可以添加数据保存逻辑
			// console.log(row)
		},
		// 订单明细
		orderDetail(row) {
			this.hotel_submit_form_title = '订单明细'
			this.table_data_detail = [row.src_channel] as any
			this.orderDetailDialog = true
		},
		// 订单删除
		orderDelete(row) {
			this.$confirm('确定要删除账单吗？', '', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => {
					deleteBillpms({
						order_code: row.ordernum,
					}).then((res) => {
						if (res.code == 0) {
							this.$message({
								type: 'success',
								message: '操作成功',
							})
							this.getTableList()
						}
					})
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除',
					})
				})
		},
		// 关闭dia重置表单
		closeHotelDialog() {
			this.orderDetailDialog = false
		},

		editOrder(row) {
			this.room_type_form_title = '调整账单'
			// this.editRoomDialog = true
			// eslint-disable-next-line
			let optionsorder = cloneDeep(row)
			this.table_data_editlist = [optionsorder]
			// console.log(row)
			this.editOrderDialog = true
		},
		putbillpms() {
			let info = this.table_data_editlist[0]
			console.log(info)

			putBillpms({
				order_code: info.pms.order_code,
				nights: info.pms.nights,
				amount: info.pms.amount,
			}).then((res) => {
				if (res.code == 0) {
					this.$message({
						type: 'success',
						message: res.msg,
					})
					this.getTableList()
					this.editOrderDialog = false
				}
			})
		},
		roomSame(row) {
			let src_channel = row.src_channel
			this.$confirm('确定要将此条渠道单同步到PMS单吗？', '', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => {
					postBillpms({
						order_code: src_channel.order_code,
					}).then((res) => {
						if (res.code == 0) {
							this.$message({
								type: 'success',
								message: res.msg,
							})
						}
						this.getTableList()
					})
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消同步',
					})
				})
		},
		confirmOrder() {
			this.$confirm('确定要提交此账单吗？', '', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => {
					putBill({
						bill_code: this.bill_code,
					}).then((res) => {
						if (res.code == 0) {
							this.$message({
								type: 'success',
								message: res.msg,
							})
						}
						// this.orderStauts = '2'
						// this.getbillList()
						this.$router.push({
							name: 'statement_of_account',
						})
					})
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消提交',
					})
				})
		},
		changeTypeTab(e) {
			this.orderStauts = e.value
			console.log(e)
		},
		formatJson(filterVal, jsonData) {
			return jsonData.map((v) => filterVal.map((j) => v[j]))
		},
		que() {
			//兼容ie10哦！
			require.ensure([], () => {
				const tHeader = ['订单编号', '客人姓名', '房型', '入住日期', '离店日期', '间夜', '结算金额'] //将对应的属性名转换成中文
				// const tHeader = [];
				const filterVal = ['order_code', 'guest_name', 'room_type', 'arr_date', 'dep_date', 'nights', 'amount'] //table表格中对应的属性名
				const data = this.formatJson(filterVal, this.table_data_bill)
				export_json_to_excel(tHeader, data, this.hotelname)
			})
		},
	},
})
